var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-picker"},[(_vm.tip)?_c('Tooltip',{attrs:{"placement":"top"}},[_c('div',{on:{"click":_vm.showItem}},[_vm._t("default")],2),_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("点击查看")])]):_c('div',{on:{"click":_vm.showItem}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }